import { Box, Flex, Radio, Skeleton, Text } from '@chakra-ui/react';
import type { CardProps } from '@ui/components/Card';
import { Card } from '@ui/components/Card';
import { useTranslations } from '@ui/i18n';
import { ColorThemeVars } from '@veno-app/chakra';
import type { ReactNode } from 'react';

export const GardenVaultCard = ({
  title,
  subtitle,
  apr,
  icon,
  isActive,
  ...props
}: CardProps & {
  title: ReactNode;
  subtitle: ReactNode;
  apr: ReactNode;
  icon: ReactNode;
}) => {
  const t = useTranslations();
  return (
    <Card
      w="0"
      flex="1"
      mx="0"
      p="8px"
      shadow={
        isActive
          ? `var(${ColorThemeVars.smallShadowActive})`
          : `var(${ColorThemeVars.parentSmallShadow})`
      }
      position="relative"
      {...props}
    >
      <Radio isChecked={isActive} position="absolute" top="10px" right="10px" />
      <Flex gap="8px" alignItems="center">
        {icon}
        <Box textStyle="bodyBold">{title}</Box>
      </Flex>
      <Box color="text-light" mt="4px" textStyle="bodySmall">
        {subtitle}
      </Box>
      <Flex gap="4px" mt="4px" flexWrap="wrap" align="center">
        <Text textStyle="bodySmall" color="text-light">
          {t('12 month APR')}:
        </Text>
        <Flex textStyle="ctaCopy" flex="1" maxW="100%">
          <Text maxW="100%">{apr ?? <Skeleton h="19px" />}</Text>
        </Flex>
      </Flex>
    </Card>
  );
};
